const ENV = process.env

ENV.API_ROOT = ENV.API_ROOT || `https://${window.location.host}`
ENV.API_BASE = ENV.API_BASE || '/backend/api/v1'
ENV.API_URL = ENV.API_URL || ENV.API_ROOT + ENV.API_BASE

if (process.env.NODE_ENV === 'development') console.info('ENV', ENV)

export default ENV



// WEBPACK FOOTER //
// ./src/env.js